import 'lightgallery.js/dist/css/lightgallery.css';
import lightGallery from 'lightgallery.js/src/js/lightgallery';

window.lightGallery(
    document.getElementById('lightgallery'),
    {
        download: false,
    }
);